import { OnInit } from '@angular/core';
import { CompanyService } from 'app/shared/services/company.service';
import { AuthService } from 'app/login/services/auth.service';
import { AlertService } from 'app/shared/services/alert.service';
var AccountOwnerSettingsComponent = /** @class */ (function () {
    function AccountOwnerSettingsComponent(companyService, authService, alertService) {
        this.companyService = companyService;
        this.authService = authService;
        this.alertService = alertService;
    }
    AccountOwnerSettingsComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.loaded = false;
        this.authService.getCurrentUser().then(function (user) {
            _this.companyService.getAccountOwnerCompany(user.companyID).then(function (c) {
                _this.loaded = true;
                _this._company = c;
            })
                .catch(function (e) {
                _this.alertService.error("Failed to get company settings.  Check your internet connection and try again");
                console.error(e);
            });
        }).catch(function (error) {
            console.error(error);
            _this.alertService.error("Failed to retrieve account settings.  Check your internet connection and try again");
        });
    };
    AccountOwnerSettingsComponent.prototype.save = function () {
        var _this = this;
        this.isSaving = true;
        this.companyService.saveAccountOwnerCompany(this._company).then(function (result) {
            _this._company = result;
            _this.isSaving = false;
            _this.alertService.success("Company settings saved!");
        })
            .catch(function (e) {
            _this.alertService.error("Failed to save company settings.  Check your internet connection and try again.");
            console.error(e);
            _this.isSaving = false;
        });
    };
    Object.defineProperty(AccountOwnerSettingsComponent.prototype, "Company", {
        get: function () {
            return this._company;
        },
        enumerable: true,
        configurable: true
    });
    return AccountOwnerSettingsComponent;
}());
export { AccountOwnerSettingsComponent };



// WEBPACK FOOTER //
// ./src/app/account-owner-settings/account-owner-settings.component.ts.pre-build-optimizer.js